import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useQuery, useMutation } from '@apollo/client';
import {
  GET_SELECTED_DEMAND_PER_ERC,
  SET_SELECTED_DEMAND_PER_ERC,
} from '../../../../../queries/engineeringQrys';
import '../../dwri.css';
import SelectedDemandTable from './SelectedDemandTable';

const DwriSelectedDemandPerErc = ({ pwsId, years = [], selectedSources = [] }) => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : { isPublic: true };
  const canEdit = user?.permissions?.includes('edit_water_use_system');

  const sourceFilter = selectedSources.length > 0 ? selectedSources : undefined;

  const queryVariables = { pwsId, years, sources: sourceFilter };
  const { data, loading, error } = useQuery(GET_SELECTED_DEMAND_PER_ERC, {
    variables: queryVariables,
    skip: !pwsId,
    fetchPolicy: 'cache-and-network',
  });

  // Each mutation returns the full recomputed 3-row list; write it straight into the query cache.
  function writeRowsToCache(cache, rows) {
    if (!rows) return;
    cache.writeQuery({
      query: GET_SELECTED_DEMAND_PER_ERC,
      variables: queryVariables,
      data: { getSelectedDemandPerErc: rows },
    });
  }

  const [updateSelectedDemandPerErc] = useMutation(SET_SELECTED_DEMAND_PER_ERC, {
    update: (cache, { data: mutationData }) => writeRowsToCache(cache, mutationData?.updateSelectedDemandPerErc),
  });

  if (error) return <p className="text-danger">Error loading Selected Demand per ERC for Minimum Sizing Requirements</p>;
  if (loading) return <p>Loading...</p>;

  const selectedDemandRows = data?.getSelectedDemandPerErc || [];
  const getRow = (selectedDemandPerErcType) => selectedDemandRows.find((row) => row.selectedDemandPerErcType === selectedDemandPerErcType) || {};
  const peakDay = getRow('peakDay');
  const averageAnnual = getRow('averageAnnual');
  const equalizationStorage = getRow('equalizationStorage');

  return (
    <>
      <Row>
        <Col><span><b>Selected Demand per ERC for Minimum Sizing Requirements</b></span></Col>
      </Row>

      <SelectedDemandTable
        valueLabel="Peak Day Demand per ERC"
        adjustedLabel="Adjusted Peak Day Demand per ERC"
        value={peakDay.calculatedErc}
        adjustedValue={peakDay.adjustedErc}
        justification={peakDay.justification}
        canEdit={canEdit}
        onSave={({ adjustedValue, justification }) => updateSelectedDemandPerErc({
          variables: {
            updateSelectedDemandInput: {
              pwsId,
              selectedDemandPerErcType: 'peakDay',
              years,
              sources: sourceFilter,
              adjustedErc: adjustedValue,
              justification,
            },
          },
        })}
      />
      <br />

      <SelectedDemandTable
        valueLabel="Average Annual Demand per ERC"
        adjustedLabel="Adjusted Average Annual Demand per ERC"
        value={averageAnnual.calculatedErc}
        adjustedValue={averageAnnual.adjustedErc}
        justification={averageAnnual.justification}
        canEdit={canEdit}
        onSave={({ adjustedValue, justification }) => updateSelectedDemandPerErc({
          variables: {
            updateSelectedDemandInput: {
              pwsId,
              selectedDemandPerErcType: 'averageAnnual',
              years,
              sources: sourceFilter,
              adjustedErc: adjustedValue,
              justification,
            },
          },
        })}
      />
      <br />

      <SelectedDemandTable
        valueLabel="Equalization Storage per ERC"
        adjustedLabel="Adjusted Equalization Storage per ERC"
        value={equalizationStorage.calculatedErc}
        adjustedValue={equalizationStorage.adjustedErc}
        justification={equalizationStorage.justification}
        canEdit={canEdit}
        onSave={({ adjustedValue, justification }) => updateSelectedDemandPerErc({
          variables: {
            updateSelectedDemandInput: {
              pwsId,
              selectedDemandPerErcType: 'equalizationStorage',
              years,
              sources: sourceFilter,
              adjustedErc: adjustedValue,
              justification,
            },
          },
        })}
      />
    </>
  );
};

export default DwriSelectedDemandPerErc;
